import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { shortenCoordinates, transformLongitudeToDMS } from "../../mapFeatures/helpers";
import { deviceIsMobile } from "../../../../features/mobileTabletChecker";
import { copyMapLink } from "../../mapFeatures/mapFunctions/copyMapLink/copyMapLink";
import { setMapInfoCoordsFormat, setMapInfoIsShown, setMapInfoScaleFormat } from "../../../../stateManagement/reducers/MapInfoSlice";
import TransportNowInfoBox from "./mapInfoWidgetAddons/TransportNowInfoBox";

const scaleApproximations = [
    "1:500 000 000", "1:250 000 000", "1:150 000 000", "1:70 000 000", "1:35 000 000", "1:15 000 000",
    "1:10 000 000", "1:4 000 000", "1:2 000 000", "1:1 000 000", "1:500 000", "1:250 000", "1:150 000",
    "1:70 000", "1:35 000", "1:15 000", "1:8 000", "1:4 000", "1:2 000", "1:1 000", "1:500", "1:250",
    "1:120", "1:60", "1:30", "1:15", "1:8", "1:4", "1:2"
];

export const MapInfoWidget = () => {
    const dispatch = useDispatch()
    const urlPrams = useParams()
    const [formattedScale, setFormattedScale] = useState<any>(null)
    const [formattedLatitude, setFormattedLatitude] = useState<any>(null)
    const [formattedLongitude, setFormattedLongitude] = useState<any>(null)
    const { coordsFormat, mapInfoIsShown, mousePosition, scaleFormat } = useAppSelector((state) => state.mapInfo)
    const { zoom, longitude: centerLongitude, latitude: centerLatitude } = useAppSelector(state => state.map.mapPosition)

    const contentHeaderWidth = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
    const mapIsOnMobileDevice = deviceIsMobile()

    const containsTransportNow = window.location.pathname.includes('transport/now');

    useEffect(() => {
        if (zoom) {
            let formattedScale = zoom
            if (scaleFormat === "scale") {
                formattedScale = scaleApproximations[Math.round(zoom)]?.toString();
            }
            setFormattedScale(formattedScale)
        }
    }, [zoom, scaleFormat])

    useEffect(() => {
        if (!mapIsOnMobileDevice) {
            if (mousePosition && zoom) {
                const [longitude, latitude] = mousePosition
                const formattedLatitude = coordsFormat === "decimal" ? shortenCoordinates(latitude, zoom) : transformLongitudeToDMS(latitude)
                const formattedLongitude = coordsFormat === "decimal" ? shortenCoordinates(longitude, zoom) : transformLongitudeToDMS(longitude)
                setFormattedLatitude(formattedLatitude)
                setFormattedLongitude(formattedLongitude)
            }
        } else {
            if (centerLongitude && centerLatitude) {
                const formattedLatitude = coordsFormat === "decimal" ? shortenCoordinates(centerLatitude, zoom) : transformLongitudeToDMS(centerLatitude)
                const formattedLongitude = coordsFormat === "decimal" ? shortenCoordinates(centerLongitude, zoom) : transformLongitudeToDMS(centerLongitude)
                setFormattedLatitude(formattedLatitude)
                setFormattedLongitude(formattedLongitude)
            }
        }
    }, [mousePosition, centerLongitude, centerLatitude, coordsFormat])

    function copyMapLinkButtonFunction() {
        copyMapLink(urlPrams)
    }

    function changeCoordinatesFormatButtonFunction() {
        const newCoordsFormat = coordsFormat === "decimal" ? "dms" : "decimal"
        dispatch(setMapInfoCoordsFormat(newCoordsFormat))
    }

    function changeScaleFormatButtonFunction() {
        const newScaleFormat = scaleFormat === "scale" ? "zoom" : "scale"
        dispatch(setMapInfoScaleFormat(newScaleFormat))
    }

    function showMapInfo() {
        dispatch(setMapInfoIsShown(true))
    }

    function hideMapInfo() {
        dispatch(setMapInfoIsShown(false))
    }

    return (
        <>
            {mapInfoIsShown
                ?
                <div className="map-info-widget-div">
                    {mapIsOnMobileDevice &&
                        <div className="map-info-widget-button hide-button" onClick={hideMapInfo}>
                            <span>Скрыть</span>
                            <i className="pi pi-arrow-down"></i>
                        </div>
                    }
                    <div className="map-info-widget-texts-group">
                        <div className="map-info-widget-text scale-text" onClick={changeScaleFormatButtonFunction}>Масштаб: {formattedScale ?? '...'}</div>
                        <div className="map-info-widget-text latitude-text" onClick={changeCoordinatesFormatButtonFunction} >Широта: {formattedLatitude ?? '...'}</div>
                        <div className="map-info-widget-text longitude-text" onClick={changeCoordinatesFormatButtonFunction} >Долгота: {formattedLongitude ?? '...'}</div>
                    </div>
                    <div className="map-info-widget-buttons-group">
                        <div className="map-info-widget-button projection-button" onClick={changeCoordinatesFormatButtonFunction}>Изменить формат координат</div>
                        <div className="map-info-widget-button copy-button" onClick={copyMapLinkButtonFunction}>Скопировать ссылку</div>
                    </div>
                    {containsTransportNow && <TransportNowInfoBox />}
                </div>
                :
                <div className="map-info-widget-div" >
                    <div className="map-info-widget-button show-button" onClick={showMapInfo}>
                        <span>Показать параметры</span>
                        <i className="pi pi-arrow-up"></i>
                    </div>
                </div>
            }
        </>
    )
}